<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('sensor_types.create')" @invoke-method="invokeMethod($event)" action="showSensorType"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetSensorTypes()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="sensor_types" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showSensorType(props.item)">
                                <td>{{ props.item.sensor_type }}</td>
                                <td>{{ props.item.sensor_description }}</td>
                                <td class="text-center" v-html="props.item.imperial_symbol"></td>
                                <td class="text-center" v-html="props.item.metric_symbol"></td>
                                <td class="text-center">{{ props.item.round_precision }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="sensor_type"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="sensor_type_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField("sensor_type_id") ? $t("lang.edit_sensor") : $t("lang.add_sensor") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeSensorTypeDialog"
                            :dialog-status="sensor_type_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="sensor_type">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="sensor_type_dialog"
                                            v-model="sensor_type.sensor_type"
                                            :label="`${$t('lang.sensor_type')} *`"
                                            :counter="showCounter(sensor_type.sensor_type, 'sensor_type.sensor_type')"
                                            :rules="ifValid('sensor_type.sensor_type')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="sensor_type.sensor_description"
                                            :label="`${$t('lang.sensor_description')} *`"
                                            :counter="showCounter(sensor_type.sensor_description, 'sensor_type.sensor_description')"
                                            :rules="ifValid('sensor_type.sensor_description')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="sensor_type.imperial_symbol"
                                            :label="`${$t('lang.imperial_symbol')} *`"
                                            :counter="showCounter(sensor_type.imperial_symbol, 'sensor_type.imperial_symbol')"
                                            :rules="ifValid('sensor_type.imperial_symbol')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="sensor_type.metric_symbol"
                                            :label="`${$t('lang.metric_symbol')} *`"
                                            :counter="showCounter(sensor_type.metric_symbol, 'sensor_type.metric_symbol')"
                                            :rules="ifValid('sensor_type.metric_symbol')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="sensor_type.round_precision"
                                            :label="`${$t('lang.round_precision')} *`"
                                            :counter="showCounter(sensor_type.round_precision, 'sensor_type.round_precision')"
                                            :rules="ifValid('sensor_type.round_precision')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('sensor_type_id')" color="error" @mouseup.left="$refs.delete_sensor_type.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeSensorTypeDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="modifySensorType(currObjField('sensor_type_id') ? 'patch' : 'post', currObjField('sensor_type_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_sensor_type"
                :heading="$t('lang.confirm_delete_header')"
                :message="$t('lang.delete_sensor')"
                @onConfirm="modifySensorType('delete', currObjField('sensor_type_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                {
                    text: this.$t("lang.sensor_type"),
                    sortable: false,
                    width: "20%",
                },
                {
                    text: this.$t("lang.sensor_description"),
                    sortable: false,
                    width: "20%",
                },
                {
                    text: this.$t("lang.imperial_symbol"),
                    sortable: false,
                    width: "20%",
                    align: "center",
                },
                {
                    text: this.$t("lang.metric_symbol"),
                    sortable: false,
                    width: "20%",
                    align: "center",
                },
                {
                    text: this.$t("lang.round_precision"),
                    sortable: false,
                    width: "20%",
                    align: "center",
                },
            ],

            sensor_type: {
                sensor_type: "",
                sensor_description: "",
                imperial_symbol: "",
                metric_symbol: "",
                round_precision: "1",
            },
            current_obj: null,
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            sensor_type_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showSensorType" },
                { title: this.$t("lang.refresh"), action: "dbGetSensorTypes" },
            ],
            dbGetSensorTypes: _.debounce(this.getSensorTypes, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchSensorType", {
                url: "sensor_types",
                method: "get",
                stateProperty: "sensor_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sensor_types) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchSensorType", {
                url: "sensor_types",
                method: "get",
                stateProperty: "sensor_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sensor_types) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_sensor_type: (state) => state.validation.rules_sensor_type,
            default_filter: (state) => state.sensor_types.sensor_types_filter,
            page: (state) => state.sensor_types.page,
            sensor_types: (state) => state.sensor_types.sensor_types,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeSensorTypeDialog() {
            this.sensor_type_dialog = false;
            this.$refs.delete_sensor_type.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getSensorTypes() {
            this.startLoader();
            this.$store
                .dispatch("fetchSensorType", {
                    url: "sensor_types",
                    method: "get",
                    stateProperty: "sensor_types",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.sensor_type_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },

        modifySensorType(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("sensor_type")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchSensorType", {
                                pk: "sensor_type_id",
                                id: id,
                                url: `sensor_types/${id ? id : ""}`,
                                method: method,
                                stateProperty: "sensor_types",
                                mutate: true,
                                body: this.sensor_type,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeSensorTypeDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showSensorType(item = null) {
            this.current_obj = item;

            if (this.$refs.sensor_type) item ? this.$refs.sensor_type.resetValidation() : this.$refs.sensor_type.reset();

            this.$nextTick(() => {
                this.assignObj(this.sensor_type, item, this.rules_sensor_type);
                this.sensor_type_dialog = true;
            });
        },
    },
};
</script>
